module.exports = __webpack_public_path__ + "img/58ddc.12540b06.svg";